module.exports = __webpack_public_path__ + "static/media/udc.f64f3f26.png";